import { WebAuthnApi } from "@/features/auth/api-client/webauthn-api-client";
import type { WebauthnOptionsParams } from "@/features/auth/types";
import { type UseMutationOptions, useMutation } from "@tanstack/react-query";

export default function useAuthenticateWebAuthnMutation(
  options?: UseMutationOptions<string, Error, WebauthnOptionsParams>
) {
  return useMutation<string, Error, WebauthnOptionsParams>({
    mutationFn: async (params: WebauthnOptionsParams) =>
      WebAuthnApi.authenticateWebAuthnUser(params.email),
    ...options
  });
}
